import { AnyAction } from '@reduxjs/toolkit'

import React, { Dispatch, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import {
  fetchGameLocalesRequest,
  postFreeGameLoginRequest,
} from '../../../redux/actions/gameActions'
import Loading from '../../../components/Loading'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'
import { ArrowRight, ArrowRotateRight } from 'iconsax-react'
import useSound from 'use-sound'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import { GameState } from '../../../redux/types/game'
import { getGameSelector } from '../../../redux/selectors/gameSelectors'
import jwt_decode from 'jwt-decode'
import * as Sentry from '@sentry/react'

const QRCodeLoginFreeGame = () => {
  const { gameId } = useParams()
  const dispatch: Dispatch<AnyAction> = useDispatch()
  const navigate = useNavigate()
  const [displayContinueGame, setDisplayContinueGame] = useState(false)
  const { t } = useTranslation()
  const {
    data: { volumeGlobal, branding },
    loading: { isSavingBookGame },
  }: GameState = useSelector(getGameSelector)
  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })
  const [gameLogo, setGameLogo] = useState<any>(null)
  useEffect(() => {
    const token = localStorage.getItem('tokenCityHunt')

    if (!token) {
      Sentry.captureMessage(
        'Uslo u nema tokena i poziva se postFreeGameLoginRequest',
        'warning',
      )
      Sentry.setContext('Variables', {
        token: token || 'nema tokena',
        gameId: gameId || 'nema game id',
      })
      dispatch(postFreeGameLoginRequest({ gameId, navigate }))
      return
    }

    try {
      const { FreeGameId, GameLogo }: any = jwt_decode(token)

      Sentry.captureMessage('Uslo u jwt_decode', 'warning')
      Sentry.setContext('Variables', {
        FreeGameId: FreeGameId || 'nema free game id',
        GameLogo: GameLogo || 'nema logo',
      })

      if (FreeGameId !== gameId) {
        Sentry.captureMessage('Uslo u FreeGameId !== gameId', 'warning')
        Sentry.setContext('Variables', {
          FreeGameId: FreeGameId || 'nema free game id',
          GameLogo: GameLogo || 'nema logo',
          gameId: gameId || 'nema game id',
        })
        dispatch(postFreeGameLoginRequest({ gameId, navigate }))
      } else {
        Sentry.captureMessage('Uslo u else FreeGameId !== gameId', 'warning')
        Sentry.setContext('Variables', {
          FreeGameId: FreeGameId || 'nema free game id',
          GameLogo: GameLogo || 'nema logo',
          gameId: gameId || 'nema game id',
        })
        dispatch(fetchGameLocalesRequest(gameId))
        setDisplayContinueGame(true)
      }

      setGameLogo(GameLogo)
    } catch (error) {
      Sentry.captureMessage(`Uslo u catch ${JSON.stringify(error)}`, 'warning')
      Sentry.setContext('Variables', {
        gameId: gameId || 'nema game id',
      })
      // Handle invalid token
      dispatch(postFreeGameLoginRequest({ gameId, navigate }))
    }
  }, [])

  if (displayContinueGame) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          padding: '5%',
        }}
      >
        {/* {gameLogo && (
          <img
            className="text-center fadeinleft animation-duration-1000"
            src={gameLogo}
            alt="Game"
            width="60%"
            style={{ marginBottom: '1rem' }}
          />
        )} */}
        <Button
          label={t('Continue')}
          icon={
            <>
              <div
                className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                style={{
                  backgroundColor: branding?.buttonPrimary.textColor,
                  color: branding?.buttonPrimary.backgroundColor,
                }}
              >
                {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
              </div>
              <ArrowRight
                color="#fff"
                // variant="Bold"
                className="icon-center"
                style={{
                  color: branding?.buttonPrimary.backgroundColor,
                }}
                // className="p-button-icon p-c p-button-icon-right"
              />
            </>
          }
          className="p-button-rounded w-full mb-3 py-3 zoominleft animation-duration-1000 uppercase"
          // className="p-button-rounded mt-4 py-3 zoominleft animation-duration-1000"
          onClick={() => {
            clickSound()
            navigate('/welcome')
          }}
          style={{
            backgroundColor: branding?.buttonPrimary.backgroundColor,
            color: branding?.buttonPrimary.textColor,
          }}
        />
        <Button
          onClick={(e) => {
            clickSound()
            dispatch(postFreeGameLoginRequest({ gameId, navigate }))
          }}
          // icon={
          //   <GridEraser color="#DF6436" variant="Bold" className="mr-1" />
          // }
          icon={
            <>
              <div
                className="p-2 p-button-icon p-button-icon-right rounded-icon-style-secondary"
                style={{ backgroundColor: branding?.buttonSecondary.textColor }}
              >
                {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
              </div>
              <ArrowRotateRight
                color={branding?.buttonSecondary.backgroundColor}
                variant="Bold"
                className="icon-center"
                // className="p-button-icon p-c p-button-icon-right"
              />
            </>
          }
          label={t('PlayAgain')}
          className="p-button-rounded p-button-outlined w-full mb-2 zoominright animation-duration-1000 uppercase"
          // className="p-button-rounded p-button-outlined w-full sign-in-btn mb-2 zoominright animation-duration-1000"
          aria-label="Text"
          aria-haspopup
          aria-controls="overlay_panel"
          style={{
            backgroundColor: branding?.buttonSecondary.backgroundColor,
            color: branding?.buttonSecondary.textColor,
            border: `2px solid ${branding?.buttonSecondary.borderColor}`,
          }}
          loading={isSavingBookGame}
        />
      </div>
    )
  }

  return <Loading />
}

export default QRCodeLoginFreeGame
